/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Faq_Q1Inputs */

const en_fc_home_faq_q1 = /** @type {(inputs: Fc_Home_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the FilmCraft video editor really free?`)
};

/**
* | output |
* | --- |
* | "Is the FilmCraft video editor really free?" |
*
* @param {Fc_Home_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_faq_q1 = /** @type {((inputs?: Fc_Home_Faq_Q1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Faq_Q1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_faq_q1(inputs)
});
export { fc_home_faq_q1 as "fc.home.faq.q1" }